import FormattedMessage from 'I18n/components/FormattedMessage';
import EmailInsightsTab from 'messaging-publishing-lib/Insights/components/EmailInsights';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const INSIGHTS_PANEL_KEY = 'aiInsight';
export const EMAIL_INSIGHTS_PANEL = {
  [INSIGHTS_PANEL_KEY]: {
    title: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      gap: 4,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "insights.panel.header"
      }), /*#__PURE__*/_jsx(UIBadge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-publishing.badges.beta"
        })
      })]
    }),
    renderTabContent: EmailInsightsTab
  }
};